module.exports = __webpack_public_path__ + "static/media/prismport-4.aa25470e.jpg";